Hop.defineModule('wishlister-counter', () => {});
